import { Button, TextField, withStyles } from '@material-ui/core';

const AppButton = withStyles(theme => ({
  root: {
    borderRadius: 40,
    borderWidth: 8,
    borderColor: theme.palette.secondary.light,
    borderStyle: 'solid'
  },
  disabled: {
    borderColor: theme.palette.grey[500]
  }
}))(Button);

const ReverseAppButton = withStyles(theme => ({
  root: {
    borderRadius: 40,
    borderWidth: 8,
    borderColor: theme.palette.secondary.light,
    borderStyle: 'solid',
    background: 'white',
    '&:hover': {
      backgroundColor: '#FFF',
      borderRadius: 40,
      borderWidth: 8,
      borderColor: theme.palette.secondary.light,
    },
  },
  disabled: {
    borderColor: theme.palette.grey[500],
  }
}))(Button);

const AppTextField = withStyles(theme => ({
  root: {
    [`& fieldset`]: {
      borderRadius: 40,
      borderWidth: 2
    },
  }
}))(TextField);

export { AppButton, ReverseAppButton, AppTextField };